export default __webpack_public_path__ + "static/media/open-eye.d6ab84bd.svg";